import type { Context } from 'react';
import { createContext } from 'react';

export type HighlightActionsContextState = {
	firstHighlightShown: boolean;
};

const defaultState: HighlightActionsContextState = {
	firstHighlightShown: false,
};

export const HighlightActionsContext: Context<HighlightActionsContextState> =
	createContext(defaultState);

HighlightActionsContext.displayName = 'HighlightActionsContext';
